import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShieldCheck, ArrowRight, Info } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * SettingsZatcaTab — Phase-1 consolidation (iter-safety).
 * ZATCA Phase 2 is now managed from the single canonical page `/zatca-phase2`
 * (onboarding, CSR, Compliance CSID, compliance checks, Production CSID, EGS
 * status, submission health, UNKNOWN/BLOCKED resolution). The legacy editable
 * Fatoora controls (manual CSID/secret, sandbox/production selector, enable
 * switch, invoice counter/auto-submit) were NOT consumed by the live Phase-2
 * engine and are removed from the normal workflow to avoid a misleading second
 * configuration source. Backend routes/collections/data are left untouched.
 * Props kept for compatibility; no longer used.
 */
export function SettingsZatcaTab() {
  const navigate = useNavigate();
  return (
    <Card className="border-violet-200" data-testid="zatca-settings-redirect-card">
      <CardHeader className="pb-3">
        <CardTitle className="font-outfit flex items-center gap-2">
          <ShieldCheck size={18} className="text-violet-600" />
          ZATCA Phase 2 E-Invoicing
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start gap-2 p-3 rounded-xl bg-violet-50 border border-violet-100">
          <Info size={16} className="text-violet-600 shrink-0 mt-0.5" />
          <p className="text-sm text-muted-foreground">
            ZATCA Phase 2 is managed from the dedicated <span className="font-semibold text-foreground">ZATCA Phase 2</span> page —
            onboarding status, environment, CSR, Compliance CSID, compliance checks, Production CSID, EGS/device status,
            submission health and blocked-chain resolution all live there as the single source of truth.
          </p>
        </div>
        <Button
          className="bg-violet-600 hover:bg-violet-700"
          onClick={() => navigate('/zatca-phase2')}
          data-testid="open-zatca-phase2-btn"
        >
          Open ZATCA Phase 2 <ArrowRight size={16} className="ml-1.5" />
        </Button>
      </CardContent>
    </Card>
  );
}

export default SettingsZatcaTab;
